import { GET_ALL_HELPER_PRICINGS } from "../actionTypes/actionTypes";
 
const getAllHelperPricings = (payload: any) => {
    return {
      type: GET_ALL_HELPER_PRICINGS,
      payload: payload,
    };
  };
  
  export { getAllHelperPricings };
  